export default "__VITE_ASSET__DURIglEK__"